// extracted by mini-css-extract-plugin
export default {"spacing":"mQpM_g"};